import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { logger } from '../lib/logger';

import commonDe from './locales/de/common.json';
import commonEn from './locales/en/common.json';
import commonFr from './locales/fr/common.json';
import commonEs from './locales/es/common.json';
import commonIt from './locales/it/common.json';
import commonPl from './locales/pl/common.json';
import commonNl from './locales/nl/common.json';

import projectsDe from './locales/de/projects.json';
import projectsEn from './locales/en/projects.json';
import projectsFr from './locales/fr/projects.json';
import projectsEs from './locales/es/projects.json';
import projectsIt from './locales/it/projects.json';
import projectsPl from './locales/pl/projects.json';
import projectsNl from './locales/nl/projects.json';

import dashboardDe from './locales/de/dashboard.json';
import dashboardEn from './locales/en/dashboard.json';
import dashboardFr from './locales/fr/dashboard.json';
import dashboardEs from './locales/es/dashboard.json';
import dashboardIt from './locales/it/dashboard.json';
import dashboardPl from './locales/pl/dashboard.json';
import dashboardNl from './locales/nl/dashboard.json';

import helpDe from './locales/de/help.json';
import helpEn from './locales/en/help.json';
import helpFr from './locales/fr/help.json';
import helpEs from './locales/es/help.json';
import helpIt from './locales/it/help.json';
import helpPl from './locales/pl/help.json';
import helpNl from './locales/nl/help.json';

function getStoredLanguage(): string {
  try {
    return localStorage.getItem('pm_language') || 'de';
  } catch {
    return 'de';
  }
}

i18n.on('missingKey', (lngs, namespace, key, _res) => {
  logger.warn('i18n', `missing key: ${namespace}:${key}`, { lngs, namespace, key });
});

i18n.use(initReactI18next).init({
  resources: {
    de: { common: commonDe, projects: projectsDe, dashboard: dashboardDe, help: helpDe },
    en: { common: commonEn, projects: projectsEn, dashboard: dashboardEn, help: helpEn },
    fr: { common: commonFr, projects: projectsFr, dashboard: dashboardFr, help: helpFr },
    es: { common: commonEs, projects: projectsEs, dashboard: dashboardEs, help: helpEs },
    it: { common: commonIt, projects: projectsIt, dashboard: dashboardIt, help: helpIt },
    pl: { common: commonPl, projects: projectsPl, dashboard: dashboardPl, help: helpPl },
    nl: { common: commonNl, projects: projectsNl, dashboard: dashboardNl, help: helpNl },
  },
  lng: getStoredLanguage(),
  fallbackLng: 'de',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

// Register i18n instance for ApiClient error translation (lazy binding)
import { registerI18nForApiClient } from '../api/client.js';
registerI18nForApiClient(i18n);

export default i18n;
